import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import type { Theme } from '@mui/material/styles'

import type { Status } from './StatusCard'

const BACKGROUND_COLOR = {
  success: (theme) => theme.palette.background.success,
  pending: (theme) => theme.palette.background.warning,
  rejected: (theme) => theme.palette.background.error,
  info: (theme) => theme.palette.background.info,
  disabled: (theme) => theme.palette.background.disabled,
  suspended: (theme) => theme.palette.tag.orange.backgroundLight,
} satisfies Record<Status, (theme: Theme) => string>

const OUTLINED_BACKGROUND_COLOR = {
  ...BACKGROUND_COLOR,
  disabled: (theme) => theme.palette.tag.grey.backgroundLight,
} satisfies Record<Status, (theme: Theme) => string>

const BORDER_COLOR = {
  success: (theme) => theme.palette.border.success,
  pending: (theme) => theme.palette.border.warning,
  rejected: (theme) => theme.palette.border.error,
  info: (theme) => theme.palette.border.info,
  disabled: (theme) => theme.palette.tag.grey.border,
  suspended: (theme) => theme.palette.tag.orange.border,
} satisfies Record<Status, (theme: Theme) => string>

export const StatusCardWrapper = styled(Card, {
  shouldForwardProp: (prop: string) => !prop.startsWith('$'),
})<{ status: Status; $outlined: boolean }>(({ status, theme, $outlined }) => ({
  '&.MuiCard-root': {
    backgroundColor: ($outlined ? OUTLINED_BACKGROUND_COLOR : BACKGROUND_COLOR)[
      status
    ](theme),
    borderRadius: '8px',
    padding: theme.spacing(2),
    boxShadow: 'unset',
    border: $outlined
      ? `${theme.border.sm} solid ${BORDER_COLOR[status](theme)}`
      : 'unset',
  },
  '&.MuiCard-root.compact': {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
}))
